import { useState } from "react";
import { Link, Flex } from "@chakra-ui/layout";

interface DocumentosListProps {
  items: {
    referencia: string;
    tipo?: string | undefined;
    nome: string;
  }[];
  collapsable: boolean;
}

export default function DocumentosList({ items, collapsable }: DocumentosListProps) {
  const [collapse, setCollapse] = useState(true);

  const slice = items.slice(0, collapse ? 2 : items.length);
  const array = collapsable ? slice : items;

  return (
    <>
      {array.map((item: any, index: number) => (
        <>
          <Link  href={item.referencia} key={index}>
            {item.tipo ? item.tipo : "Arquivo"}
          </Link>
          <br />
        </>
      ))}
      {collapsable ?   <Flex fontWeight="bold" mt={1} onClick={() => setCollapse(!collapse)} cursor="pointer">
        {collapse ?  "Mostrar mais" : "Mostar menos" }
      </Flex> : null}
    
    </>
  );
}
